import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/donate')({
  head: () => ({
    meta: [
      { title: 'donate - jfrader' },
      { name: 'description', content: 'donate to jfrader.' },
      { property: 'og:title', content: 'donate - jfrader' },
      { property: 'og:description', content: 'donate to jfrader.' },
      { property: 'og:url', content: 'https://jfrader.com/donate' },
    ],
    links: [
      { rel: 'canonical', href: 'https://jfrader.com/donate' }
    ]
  }),
  beforeLoad: () => {
    throw redirect({ to: '/tips', replace: true })
  },
})
